import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  Menu, 
  User, 
  Settings, 
  TrendingUp, 
  Gift, 
  FileText, 
  Shield, 
  LogOut, 
  Wallet,
  Bell 
} from 'lucide-react';
import { useDisconnect } from 'wagmi';
import { useAuth } from '../contexts/AuthContext';
import WalletConnect from './WalletConnect';

export default function HoverMenu() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { isLoggedIn, user, address } = useAuth();
  const { disconnect } = useDisconnect();
  const closeTimer = React.useRef();

  const handleMouseEnter = () => {
    if (closeTimer.current) {
      clearTimeout(closeTimer.current);
    }
    setOpen(true);
  };

  const handleMouseLeave = () => {
    closeTimer.current = setTimeout(() => {
      setOpen(false);
    }, 200);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDisconnect = () => {
    disconnect();
    handleClose();
  };

  const handleMenuItemClick = (item) => {
    console.log(`Clicked: ${item}`);
    handleClose();
    
    switch (item) {
      case 'Profile':
        navigate('/profile');
        break;
      case 'Notifications':
        navigate('/notifications');
        break;
      case 'Settings':
        navigate('/settings');
        break;
      case 'Watchlist':
        navigate('/predictions');
        break;
      case 'Claim Promo':
        navigate('/claim');
        break;
      case 'Documentation':
        navigate('/docs');
        break;
      case 'Terms of Use':
        navigate('/terms');
        break;
      default:
        console.log(`No navigation defined for: ${item}`);
    }
  };

  return (
    <div
      className="relative"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{ display: 'inline-block' }}
    >
      <button
        className="flex items-center justify-center w-8 h-8 rounded-lg bg-white/10 hover:bg-white/20 text-white focus:outline-none"
        aria-label="Open menu"
      >
        <Menu className="w-5 h-5" />
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-64 bg-plypto-bg border border-white/10 rounded-xl shadow-lg z-50 py-2 animate-fade-in">
          {!isLoggedIn ? (
            // 未登录状态
            <>
              <WalletConnect variant="menu" />
              <div className="border-t border-white/10 my-1"></div>
              <button
                className="block w-full text-left px-4 py-2 text-sm text-white hover:bg-white/10 transition-colors"
                onClick={() => handleMenuItemClick('Documentation')}
              >
                Documentation
              </button>
              <button
                className="block w-full text-left px-4 py-2 text-sm text-white hover:bg-white/10 transition-colors"
                onClick={() => handleMenuItemClick('Terms of Use')}
              >
                Terms of Use
              </button>
            </>
          ) : (
            // 已登录状态
            <>
              {/* 用户信息区域 */}
              <div className="px-4 py-3 border-b border-white/10">
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center">
                    <User className="w-5 h-5 text-white" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="text-white font-medium text-sm truncate">
                      {user?.username || 'User'}
                    </div>
                    <div className="text-gray-400 text-xs truncate">
                      {address ? `${address.slice(0, 6)}...${address.slice(-4)}` : ''}
                    </div>
                  </div>
                </div>
              </div>
              
              {/* 菜单选项 */}
              <div className="py-1">
                <button
                  className="flex items-center w-full text-left px-4 py-2 text-sm text-white hover:bg-white/10 transition-colors"
                  onClick={() => handleMenuItemClick('Profile')}
                >
                  <User className="w-4 h-4 mr-3 text-gray-400" />
                  User Profile
                </button>
                <button
                  className="flex items-center w-full text-left px-4 py-2 text-sm text-white hover:bg-white/10 transition-colors"
                  onClick={() => handleMenuItemClick('Settings')}
                >
                  <Settings className="w-4 h-4 mr-3 text-gray-400" />
                  Settings
                </button>
                <button
                  className="flex items-center w-full text-left px-4 py-2 text-sm text-white hover:bg-white/10 transition-colors"
                  onClick={() => handleMenuItemClick('Notifications')}
                >
                  <Bell className="w-4 h-4 mr-3 text-gray-400" />
                  Notifications
                </button>
                <div className="border-t border-white/10 my-1"></div>
                <button
                  className="flex items-center w-full text-left px-4 py-2 text-sm text-white hover:bg-white/10 transition-colors"
                  onClick={() => handleMenuItemClick('Watchlist')}
                >
                  <TrendingUp className="w-4 h-4 mr-3 text-gray-400" />
                  My Predictions
                </button>
                <button
                  className="flex items-center w-full text-left px-4 py-2 text-sm text-white hover:bg-white/10 transition-colors"
                  onClick={() => handleMenuItemClick('Claim Promo')}
                >
                  <Gift className="w-4 h-4 mr-3 text-gray-400" />
                  Claim Plyp
                </button>
                <div className="border-t border-white/10 my-1"></div>
                <button
                  className="flex items-center w-full text-left px-4 py-2 text-sm text-white hover:bg-white/10 transition-colors"
                  onClick={() => handleMenuItemClick('Documentation')}
                >
                  <FileText className="w-4 h-4 mr-3 text-gray-400" />
                  Documentation
                </button>
                <button
                  className="flex items-center w-full text-left px-4 py-2 text-sm text-white hover:bg-white/10 transition-colors"
                  onClick={() => handleMenuItemClick('Terms of Use')}
                >
                  <Shield className="w-4 h-4 mr-3 text-gray-400" />
                  Terms of Use
                </button>
                <div className="border-t border-white/10 my-1"></div>
                <button
                  className="flex items-center w-full text-left px-4 py-2 text-sm text-red-400 hover:bg-red-500/10 transition-colors"
                  onClick={handleDisconnect}
                >
                  <LogOut className="w-4 h-4 mr-3 text-red-400" />
                  Disconnect
                </button>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}
